import React from 'react';
import { Carousel } from '@mantine/carousel';
import { Image, Text, Container } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/carousel/styles.css';
import Categories from './Categories';
import SEO from '../Layout/seo';

const Home: React.FC = () => {
	const slides = [
		{
			src: '/images/top_slider/slider1.png'
		},
		{
			src: '/images/top_slider/slider2.png'
		},
		{
			src: '/images/top_slider/slider3.png'
		},
	];

	return (
		<div>
			<SEO
				title="Scorpio Classics"
				description="Explore Scorpio Classics for a curated selection of classic and new motorbikes, authentic vintage jukeboxes, metal automobile signs, and unique memorabilia. Quality and passion for vintage collectibles."
				keywords="classic motorbikes, new motorbikes, vintage jukeboxes, metal automobile signs, vintage memorabilia, Scorpio Classics"
				imageUrl="https://www.scorpioclassics.com/images/top_slider/slider3.png"
				slug=""
			/>
			<Container>
				<Carousel
					withIndicators
					height={400}
					slideSize="100%"
					slideGap="md"
					loop
					align="center">
					{slides.map((slide, index) => (
						<Carousel.Slide key={index}>
							<div style={{ position: 'relative', height: '100%' }}>
								<Image
									src={slide.src}
									alt={`Slide ${index + 1}`}
									fit="cover"
									height={400}
								/>
							</div>
						</Carousel.Slide>
					))}
				</Carousel>
			</Container>
			<Container>
				<Text mt="md">Welcome to Scorpio Classics, your premier destination for classic and new motorbikes, vintage jukeboxes, metal automobile signs, and unique memorabilia. Our collection is meticulously curated to cater to enthusiasts and collectors alike. Discover the timeless appeal of our products and the stories they tell."</Text>
				<Text mt="md">
					Born from the collaboration of two like-minded people, who for over 30
					years have shared the passion for rare and collectable motor vehicles,
					parts and memorabilia, Scorpio Classics aims to bring to the
					marketplace a great and diverse choice of interesting vehicles,
					automobilia and cool items from years gone by.
				</Text>
			</Container>

			<Categories isHomePage />
		</div>
	);
};

export default Home;
